import { render } from "./TableTd.vue?vue&type=template&id=42b2d91f&scoped=true"
import script from "./TableTd.vue?vue&type=script&lang=js"
export * from "./TableTd.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-42b2d91f"

export default script